export const projects = {
  it: {
    title: "Soluzioni Flagship",
    subtitle: "Sistemi intelligenti progettati per risolvere le sfide aziendali più complesse.",
    hero: {
      title: "Asset",
      highlight: "Operativi",
      description: "Infrastrutture digitali progettate per efficienza e scalabilità."
    },
    ui: {
      uptime: "Uptime",
      efficiency: "Efficienza",
      accessGranted: "ACCESSO PROGETTO CONSENTITO",
      techStack: "Stack Tecnologico",
      performance: "Impatto Performance",
      velocity: "Alta Velocità",
      viewLive: "Vedi Sistema Live",
      restricted: "Accesso Riservato"
    },
    items: [
      {
        icon: "Network",
        title: "Piattaforma Workflow 'Vector'",
        description: "Il motore per i processi aziendali. Esegue workflow, approvazioni e task in modo strutturato, tracciabile e sicuro, eliminando il caos delle email."
      },
      {
        icon: "BrainCircuit",
        title: "Sistema AI 'Cortex-Zero'",
        description: "La memoria sintetica per l'azienda. Un'AI che 'comprende' il caos di email, Slack e meeting per fornire risposte e insight istantanei."
      },
      {
        icon: "Rocket",
        title: "LAUNCH: Presenza Digitale",
        description: "Pacchetto 'chiavi in mano' per PMI. Sito web, CRM e automazioni WhatsApp con AI per catturare ogni lead 24/7. Online in 14 giorni, nessun contatto perso."
      },
      {
        icon: "BarChart4",
        title: "Dashboard Analitiche Custom",
        description: "Dashboard in tempo reale per monitorare KPI, performance e pipeline. Trasforma i dati grezzi in decisioni strategiche immediate."
      },
      {
        icon: "Zap",
        title: "CRM-Lite & Automazione Vendite",
        description: "Un sistema CRM interno per gestire contatti, lead e appuntamenti, potenziato da automazioni intelligenti."
      }
    ]
  },
  en: {
    title: "Flagship Solutions",
    subtitle: "Intelligent systems designed to solve complex business challenges.",
    hero: {
      title: "Operational",
      highlight: "Assets",
      description: "Digital infrastructures designed for efficiency and scalability."
    },
    ui: {
      uptime: "Uptime",
      efficiency: "Efficiency",
      accessGranted: "PROJECT ACCESS GRANTED",
      techStack: "Technology Stack",
      performance: "Performance Impact",
      velocity: "High Velocity",
      viewLive: "View Live System",
      restricted: "Restricted Access"
    },
    items: [
      {
        icon: "Network",
        title: "Workflow Platform 'Vector'",
        description: "The engine for business processes. Executes workflows, approvals, and tasks in a structured, traceable, and secure way, eliminating email chaos."
      },
      {
        icon: "BrainCircuit",
        title: "AI System 'Cortex-Zero'",
        description: "The synthetic memory for the company. An AI that 'understands' the chaos of emails, Slack, and meetings to provide instant answers and insights."
      },
      {
        icon: "Rocket",
        title: "LAUNCH: Digital Presence",
        description: "Turnkey package for SMEs. Website, CRM, and AI-powered WhatsApp automations to capture every lead 24/7. Online in 14 days, no contacts lost."
      },
      {
        icon: "BarChart4",
        title: "Custom Analytics Dashboards",
        description: "Real-time dashboards to monitor KPIs, performance, and pipelines. Transforms raw data into immediate strategic decisions."
      },
      {
        icon: "Zap",
        title: "CRM-Lite & Sales Automation",
        description: "An in-house CRM system to manage contacts, leads, and appointments, powered by intelligent automation."
      }
    ]
  }
};